// Same "show first, refresh in the background" pattern as overviewStore —
// the page paints whatever was last seen for the active range, then
// `useGraphOutput` fetches and replaces it. If the response shape
// changes (e.g. a new bannerStatus, a different number of points), the
// cache is overwritten in place.

const KEY_PREFIX = 'hrv4_graphs_cache_v1_';
const TTL_MS = 60 * 60 * 1000; // 1 hour

function keyFor(range) {
  return `${KEY_PREFIX}${range || 'default'}`;
}

export function hasValidGraphCache(range) {
  try {
    const raw = localStorage.getItem(keyFor(range));
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.timestamp !== 'number') return false;
    return Date.now() - parsed.timestamp < TTL_MS;
  } catch (_) {
    return false;
  }
}

export function loadStoredGraph(range) {
  try {
    const raw = localStorage.getItem(keyFor(range));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && parsed.data ? parsed.data : null;
  } catch (_) {
    return null;
  }
}

export function storeGraph(range, data) {
  if (!data) return;
  try {
    localStorage.setItem(
      keyFor(range),
      JSON.stringify({ data, timestamp: Date.now() })
    );
  } catch (_) {
    // Best-effort.
  }
}

export function clearGraphCache(range) {
  try {
    if (range) {
      localStorage.removeItem(keyFor(range));
    } else {
      // Wipe every cached range — used when a model run completes and
      // every tab needs to be re-fetched.
      for (let i = localStorage.length - 1; i >= 0; i -= 1) {
        const k = localStorage.key(i);
        if (k && k.startsWith(KEY_PREFIX)) localStorage.removeItem(k);
      }
    }
  } catch (_) {}
}